module.exports = __webpack_public_path__ + "img/breast-feeding.ba22910.png";